var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"cf-icon",style:({width: _vm.size+'px', height: _vm.size+'px'})},[_c(_vm.icon,{tag:"component",attrs:{"fill":_vm.color}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }